import routes from 'global/Constants/routes';
import { lazy } from 'react';

const Verify = lazy(() => import('../../pages/dashboard/payment/VerifyPage'));

export const paymentRoutes = (hasAccessLevel: (_level: number) => boolean) => [
  {
    path: routes.verify.path,
    component: Verify,
    isPrivate: routes.verify.isPrivate,
    accessRole: hasAccessLevel(10),
  },
];
